import { render } from "./dependants-exclusion-list.vue?vue&type=template&id=4104ca84"
import script from "./dependants-exclusion-list.vue?vue&type=script&lang=js"
export * from "./dependants-exclusion-list.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__